"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vdsSpacingScale = void 0;
var vdsSpacingScale = {
  "1X": 1,
  "2X": 2,
  "3X": 3,
  "4X": 4,
  "5X": 5,
  "6X": 6,
  "8X": 8,
  "12X": 12,
  "16X": 16,
  "32X": 32
};
exports.vdsSpacingScale = vdsSpacingScale;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/theme/dist/cjs/layout/spacing/spacingScale.js
// module id = 593
// module chunks = 0